export default "__VITE_ASSET__Fc9$$iZO__"